/*
Initialises jspsych with progress bar details.
*/

import { initJsPsych } from "jspsych";
import i18next from "i18next"; //get the i18next functions
import "../i18n/i18n"; //get i18next class as defined in i18n.js to get the text for progress bar
import store from "store2"; //storing session data
import { dashToCamelCase } from "./shared/helpers";

const redirectInfo = {
  cdm: "https://stanford-cogsci.org:8880/landing_page.html",
  demo: "https://roar.stanford.edu/",
  prolific: {
    YeatmanLab: {
      fluencyArf: "https://app.prolific.com/submissions/complete?cc=CDAO8JGT",
      fluencyCalf: "https://app.prolific.com/submissions/complete?cc=C13EIE8W",
    },
  },
};

const prolificNumberLab = (group, study, assessmentPid, taskName) => {
  let urlString;
  if (taskName === "fluency-arf") {
    urlString =
      "https://roam-fluency.web.app/?audio=false&consent=false&keyboardPractice=false&labId=numberLab&recruitment=prolific&responseMode=production&storyOption=false&task=fluency-calf&mode=default&lng=en&participant=" +
      assessmentPid +
      "&group=" +
      group.toString() +
      "&study=" +
      study;
  } else if (taskName === "fluency-calf") {
    if (group > 0 && group < 5) {
      urlString =
        "https://run.pavlovia.org/alexamogan/letterwm/?participant=" +
        assessmentPid +
        "&group=" +
        group.toString() +
        "&study=" +
        study;
    } else {
      urlString =
        "https://run.pavlovia.org/alexamogan/numberwm/?participant=" +
        assessmentPid +
        "&group=" +
        group.toString() +
        "&study=" +
        study;
    }
  } else if (taskName === "roam-alpaca") {
    if (group % 2 === 1) {
      urlString =
        "https://run.pavlovia.org/alexamogan/lexicaldecision/?participant=" +
        assessmentPid +
        "&group=" +
        group.toString() +
        "&study=" +
        study;
    } else {
      urlString =
        "https://run.pavlovia.org/alexamogan/numbercomparison/?participant=" +
        assessmentPid +
        "&group=" +
        group.toString() +
        "&study=" +
        study;
    }
  }
  return urlString;
};

export const jsPsych = initJsPsych({
  show_progress_bar: true,
  auto_update_progress_bar: false,
  message_progress_bar: `${i18next.t("progressBar")}`,
  on_finish: () => {
    document.body.style.cursor = "auto";
    const config = store.session.get("config");
    if (config.recruitment === "cdm") {
      window.location.href = redirectInfo.cdm;
    }
    if (config.recruitment === "demo") {
      window.location.href = redirectInfo.demo;
    }
    if (config.recruitment === "prolific") {
      if (config.labId === "numberLab") {
        window.location.href = prolificNumberLab(
          config.group,
          config.study,
          config.pid,
          config.taskName,
        );
      } else {
        window.location.href =
          redirectInfo.prolific[config.labId][dashToCamelCase(config.taskName)];
      }
    }
  },
});
